<template>
  <div class="chat-pane">
    <b-tabs pills content-class="mt-3">
      <b-tab active>
        <template class="tab-select" #title>
          <i class="fa fa-comment-dots" />
          Chat
        </template>
        <hr>
        <div v-if="conversation === null">
          <div id="channels" class="conversations">
            <a v-b-toggle.collapse-1 class="collapser">
              <span class="when-opened">
                <i class="fa fa-chevron-down toggler" />
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-right toggler" />
              </span>
              Channels
            </a>
            <b-collapse id="collapse-1" visible class="convo-block mt-2">
              <span v-for="(channel, index) in conversations" v-if="channel.id < 0" :key="index">
                <a v-if="channel.unread > 0" class="convo unread-convo" @click="openConvo(channel.id)">
                  # {{ channel.name }}
                  <span class="right unread">
                    {{ channel.unread }}
                  </span>
                </a>
                <a v-else class="convo" @click="openConvo(channel.id)">
                  # {{ channel.name }}
                </a>
              </span>
            </b-collapse>
          </div>
          <div id="direct" class="conversations">
            <a v-b-toggle.collapse-2 class="collaper">
              <span class="when-opened">
                <i class="fa fa-chevron-down toggler" />
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-right toggler" />
              </span>
              Direct Messages
            </a>
            <b-collapse id="collapse-2" visible class="convo-block mt-2">
              <span v-for="(user, index) in conversations" v-if="user.id >= 0" :key="index">
                <a v-if="user.unread > 0" class="convo unread-convo" @click="openConvo(user.id, user.name)">
                  <span v-if="user.role">
                    {{ user.role }}
                  </span>
                  <span v-else>
                    {{ user.name }}
                  </span>
                  <span v-if="user.unread > 0" class="right unread">
                    {{ user.unread }}
                  </span>
                </a>
                <a v-else class="convo" @click="openConvo(user.id, user.name)">
                  <span v-if="user.role">
                    {{ user.role }}
                  </span>
                  <span v-else>
                    {{ user.name }}
                  </span>
                </a>
              </span>
            </b-collapse>
          </div>
        </div>
        <div v-if="conversation !== null" class="convo-pane">
          <div class="header">
            <a @click="backToList">
              <i class="fa fa-arrow-alt-circle-left" />
            </a>
            <div class="content d-inline-block">
              <span v-if="conversation.id < 0" class="text"># </span>{{ conversation.name }}
              <br>
              <span v-if="conversation.id < 0" class="members">
                {{ members }} members in this channel
              </span>
            </div>
          </div>
          <div class="card-body p-0 messages">
            <ul class="list-unstyled">
              <li v-for="(message, messageindex) in conversation.messages" :key="messageindex" class="p-2">
                <strong>{{ message[0] }}</strong>
                {{ message[1] }}
                <video width="320" height="240" controls>
                  <source :src="message[4]" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <span class="timestamp">{{ message[3] | formatDate }}</span>
              </li>
            </ul>
            <input
              v-model="newMessage"
              type="text"
              name="message"
              placeholder="Enter your message..."
              class="form-control footer"
              @keyup.enter="sendMessage()"
            >
          </div>
        </div>
      </b-tab>
      <b-tab title="Cotacts">
        <template #title>
          <i class="fa fa-address-book" />
          Contacts
        </template>
        <hr>
        <p>I'm the second tab</p>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState, mapGetters } from 'vuex'
import * as vm from 'vue'
import video from '../modals/video'

export default {
  layout: 'basepcs',

  metaInfo() {
    return { title: 'Chat' }
  },

  data: () => ({
    title: window.config.appName,
    newMessage: '',
    activeUsers: [],
    groupID: '',
    conversation: null,
    newMsg: {
      message: null,
      recipient: null,
      recipientid: null,
      name: null,
      id: null,
      timestamp: null,
    }
  }),

  computed: {
    ...mapState({
      conversations: state => state.chat.conversations,
      user: state => state.auth.user,
      members: function() {
        if (this.conversation.members.length === 0) {
          return 'all'
        } else {
          return this.conversation.members.length
        }
      },
    }),
    ...mapGetters({
      classId: 'auth/classId',
    })
  },

  created() {
    axios.post('/api/getGroup', {
      params: {
        pcs: localStorage.getItem('pcs'),
        classId: this.classId,
      },
    })
      .then(response => {
        this.groupID = response.data

        this.grabConversations()
        if (this.groupID) {
          // eslint-disable-next-line no-undef
          Echo.join('group.chat.' + this.groupID)
            .here(user => {
              // console.log('here')
              this.activeUsers = user
            })
            .joining(user => {
              this.activeUsers.push(user)
            })
            .leaving(user => {
              // eslint-disable-next-line eqeqeq
              this.activeUsers = this.activeUsers.filter(u => u.id != user.id)
            })
            .listen('MessageSent', (event) => {
              event.conversation = this.conversation
              this.addMessage(event)
            })
        }
      })
  },

  methods: {
    ...mapActions({
      updateState: 'chat/saveState',
      processEvent: 'events/processEvent',
      addMessage: 'chat/addMessage',
    }),

    test: function() {
      this.processEvent({eventId: 100})
    },

    grabConversations: function() {
      axios.post('/api/pcs/chat', {
        params: {
          pcs: localStorage.getItem('pcs'),
          group: this.groupID,
          classId: this.classId,
        },
      })
        .then(response => {
          this.users = response.data['users']
          this.channels = response.data['channels']
          this.users.forEach((user, index) => {
            let found = this.checkUser(user.name)
            if (!found) {
              // vm.set(this.conversations, user.name, { 'id': user.id, 'name': user.name, 'messages': [] })
            }
          })
        })
    },

    openConvo: function(id, name) {
      if (id === 0) {
        this.conversations.forEach(convo => {
          if ((convo['id'] === id) && (convo['name'] === name)) {
            convo['unread'] = 0
            this.conversation = convo
          }
        })
      } else {
        this.conversations.forEach(convo => {
          if (convo['id'] === id) {
            convo['unread'] = 0
            this.conversation = convo
          }
        })
      }
      this.updateState()
    },

    backToList: function() {
      this.conversation = null
    },

    checkUser: function(user) {
      this.conversations.forEach((check, dex) => {
        if (user.name === check.name) {
          return true
        }
      })
      return false
    },

    sendMessage: function() {
      let recipient = this.conversation.name
      let recipientid = this.conversation.id

      let event = {
        message: this.newMessage,
        sender: this.user.name,
        senderid: this.user.id,
        recipient: recipient,
        recipientid: recipientid,
        timestamp: new Date(),
        conversation: this.conversation,
      }

      this.addMessage(event)

      if (recipientid === 0) {
        // sending to AI
        this.sendToAi(recipient)
      } else {
        if (recipientid > 0) {
          // sending to user
          let active = this.checkIfOnline(recipient)
          if (active) {
            // if they are on broadcast normally
            this.broadcast(recipient, recipientid)
          } else {
            // if they aren't on
            this.sendToOffline(recipient, recipientid, false)
          }
        } else {
          // sending to channel
          this.broadcast(recipient, recipientid)
          // add message to states of users not online
          if (this.conversation.members === []) {
            // channel including all team members
            this.users.forEach((user, index) => {
              // only check other users and not AIs
              if (user.id > 0) {
                if (!this.checkIfOnline(user.name)) {
                  this.sendToOffline(user.name, user.id, recipientid)
                }
              }
            })
          } else {
            // exclusive channel
            this.conversation.members.forEach(id => {
              this.users.forEach((user, index) => {
                // only check other users and not AIs
                if (user.id === id) {
                  if (!this.checkIfOnline(user.name)) {
                    this.sendToOffline(user.name, id, recipientid)
                  }
                }
              })
            })
          }
        }
      }
      this.updateStateMessages()

      this.newMessage = ''
    },

    checkIfOnline: function(recipient) {
      let active = false
      // loop through active users
      this.activeUsers.forEach((user, index) => {
        // check if the other user is on
        if (user.name === recipient) {
          active = true
        }
      })

      if (active) {
        return true
      } else {
        return false
      }
    },

    sendToOffline: function(recipient, id, general) {
      axios.post('/api/messageOffline', {
        params: {
          message: this.newMessage,
          pcs: localStorage.getItem('pcs'),
          classId: this.classId,
          sender: this.user.name,
          senderid: this.user.id,
          recipient: recipient,
          recipientid: id,
          general: general,
          timestamp: new Date(),
        },
      })
    },

    broadcast: function(recipient, id) {
      axios.post('/api/message', {
        params: {
          message: this.newMessage,
          pcs: localStorage.getItem('pcs'),
          classId: this.classId,
          recipient: recipient,
          recipientid: id,
          name: this.user.name,
          id: this.user.id,
          timestamp: new Date(),
          all: false,
        },
      })
    },

    sendToAi: function(recipient) {
      console.log('sending message to ', recipient)
    },

    updateStateMessages: function() {
      // save the updated message thread in the database
      this.updateState({
        module: 'chat',
        content: 'update is already in state',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.testing{
  background-color: var(--primary);
}
  .tabs {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
  .tabs > div{
    flex: 0 1 59px;
  }
  .tab-content {
    flex: 1 1 auto;
    display: flex;
    flex-flow: column;
  }
  .tab-pane {
    flex: 1 1 auto;
    height: inherit;
    display: flex;
    flex-flow: column;
  }
  .chat-pane{
    display: flex;
    flex-flow: column;
    height: 100%;
    margin: 0;
  }
  hr {
    margin: 0;
  }
  .right {
    float: right;
  }
  /* Navigation Pills */
  .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #007bff;
    background-color: transparent;
    border-bottom: solid 3px #007bff;
    border-radius: 0;
  }

  .nav {
    align-content: center;
    margin: 10px;
  }

  .nav-item {
    width: fit-content;
    margin: auto;
  }

  .nav-link {
    padding-left: 0;
    padding-right: 0;
  }

  /* Channel and Direct Conversation Select */
  .conversations {
    margin: 25px;
    .collapser {
      color: gray;
    }
    .toggler {
      font-size: 8px;
    }
  }

  .convo-block {
    margin-left: 20px;
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  .convo {
    display: block;
    color: black !important;
    padding: 6px;
    border-radius: .5rem;
  }

  .unread {
    font-size: 10px;
    color: white;
    padding: 0 10px;
    border-radius: .5rem;
    background-color: #7abaff;
  }

  .unread-convo {
    color: #007bff;
    font-weight: bold;
    background-color: #9de0f6;
  }

  /* Conversation pane */
  .convo-pane {
    height: inherit;
    flex: 1 1 auto;
    display: flex;
    flex-flow: column;
    overflow-y: auto;
    .header {
      flex: 0 1 auto;
      padding: 10px;
      a {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
      }
      .content {
        margin-left: 20px;
        .text {

        }
        .members {
          font-size: 10px;
        }
      }
    }
    .messages {
      flex: 1 1 auto;
      height: inherit;
      display: flex;
      position: relative;
      flex-flow: column;
      margin-bottom: 10px;
      overflow-y: auto;
      ul {
        max-height: 450px;
        flex: 1 1 auto;
        height: auto;
        overflow-y: auto;
      }
      .footer {
        flex: 0 1 40px;
      }
    }
  }
</style>
